import { render, staticRenderFns } from "./InfosResources.vue?vue&type=template&id=bcd72886&scoped=true"
import script from "./InfosResources.vue?vue&type=script&lang=js"
export * from "./InfosResources.vue?vue&type=script&lang=js"
import style0 from "./InfosResources.vue?vue&type=style&index=0&id=bcd72886&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd72886",
  null
  
)

export default component.exports